import { InitialsColourEnum } from '../../atoms/Initials/types';

export const initialColours : InitialsColourEnum[] = ['Green', 'Amber', 'Aqua', 'Purple'];

export const CUSTOM_EMAIL_INDEX = 4;